
import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import OnboardingPage from "./pages/OnboardingPage";
import Layout from "./components/Layout";
import NotFound from "./pages/NotFound";
import HiringPage from "./pages/HiringPage";
import DemoPage from "./pages/DemoPage";
import SettingsPage from "./pages/SettingsPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import StaffPage from "./pages/StaffPage";
import PlansPage from "./pages/PlansPage";
import ActivityHistoryPage from "./pages/ActivityHistoryPage";
import PricingPage from "./pages/PricingPage";
import SupportPage from "./pages/SupportPage";
import DashboardPage from "./pages/DashboardPage";
import ProtectedRoute from "./components/routing/ProtectedRoute";
import ResetPasswordPage from "./pages/ResetPasswordPage";

export const router = createBrowserRouter([
  // Public routes
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/login",
    element: <AuthPage defaultTab="signin" />,
  },
  {
    path: "/signup",
    element: <AuthPage defaultTab="signup" />,
  },
  {
    path: "/forgot-password",
    element: <AuthPage defaultTab="reset" />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/onboarding",
    element: <OnboardingPage />,
  },
  {
    path: "/demo",
    element: <DemoPage />,
  },
  
  // Protected routes under /app
  {
    path: "/app",
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        path: "",
        element: <DashboardPage />,
      },
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "hiring",
        element: <HiringPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "integrations",
        element: <IntegrationsPage />,
      },
      {
        path: "communication-channels/slack",
        element: <Navigate to="/app/integrations" state={{ defaultTab: "communication" }} replace />,
      },
      {
        path: "communication-channels",
        element: <Navigate to="/app/integrations" state={{ defaultTab: "communication" }} replace />,
      },
      {
        path: "staff",
        element: <StaffPage />,
      },
      {
        path: "staff/:staffId",
        element: <StaffPage />,
      },
      {
        path: "plans",
        element: <PlansPage />,
      },
      {
        path: "activities",
        element: <ActivityHistoryPage />,
      },
      {
        path: "support",
        element: <SupportPage />,
      }
    ],
    errorElement: <NotFound />,
  },
  
  // Catch-all route
  {
    path: "*",
    element: <NotFound />,
  },
]);
